import { PASSWORD_REGEX } from '@gozoki/tools'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

const zNewPasswordForm = z.object({
  password: z.string().min(8).regex(PASSWORD_REGEX),
})

export type NewPasswordForm = z.infer<typeof zNewPasswordForm>

// Form hook
export const useNewPasswordForm = () => {
  const form = useForm<NewPasswordForm>({
    // Validation function
    defaultValues: {
      password: '',
    },
    resolver: zodResolver(zNewPasswordForm),
  })

  return form
}
